// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1selt","inputDescription":"styles_inputDescription__23JMl"};